import * as React from 'react';
import FaqItem from './FaqItem';
import { Container } from '@mui/material';

export default function FaqList() {
    const faqData = [
        {
            question: "Zaproszenie",
            answer: [
                "Zapraszamy Was do świętowania dnia, w którym miłość, przyjaźń i marzenia staną się jednym.",
                "",
                "W dniu naszego ślubu chcemy być otoczeni tymi, którzy są dla nas najważniejsi.",
                "",
                "Wasza obecność sprawi, że ten dzień będzie naprawdę niezapomniany."
            ],
            quote: "„Każdy początek to tylko ciąg dalszy, a księga zdarzeń zawsze otwarta w połowie.”",
            quoteAuthor: "Wisława Szymborska"
        },
        {
            question: "Ślub",
            answer: [
                "Uroczystość zawarcia Sakramentu Małżeństwa odbędzie się w Kościele św. Antoniego z Padwy przy ul. Panewnickiej 451, o godzinie 13:30"
            ],
            iframeSrc: "https://www.google.com/maps/embed/v1/place?key=AIzaSyDQ_Ao-DIExs3lQ7BAs-Zdw4ggY2zWrVlE&q=Kościół+św.+Antoniego+z+Padwy,Panewnicka+451,Katowice+Poland"
        },
        {
            question: "Wesele",
            answer: [
                "Po ceremonii zaślubin zapraszamy do Restauracji Biały Dom w Paniówkach, przy ul. Karola Darwina 50"
            ],
            iframeSrc: "https://www.google.com/maps/embed/v1/place?key=AIzaSyDQ_Ao-DIExs3lQ7BAs-Zdw4ggY2zWrVlE&q=Restauracja+Biały+Dom,Karola+Darwina+50,Paniówki+Poland"
        },
        {
            question: "Jedzenie",
            answer: [
                "Jeśli stosujecie dietę wegetariańską, wegańską, bezglutenową lub inną, prosimy o poinformowanie nas o tym przy potwierdzaniu przybycia."
            ]
        },
        {
            question: "Prezenty",
            answer: [
                "Wasza obecność to dla nas wszystko.",
                "",
                "Jeśli jednak planujecie prezent, zamiast rzeczy – pieniądze na wspólne marzenia.",
                "",
                "A zamiast kwiatów? Zdrapka, Lotto albo dobre wino – kto wie, może szczęście się do nas jeszcze bardziej uśmiechnie :)"
            ]
        },
        {
            question: "Transport",
            answer: [
                "Z kościoła do restauracji jest około 25 minut jazdy samochodem. Parking znajduje się bezpośrednio przy obiekcie.",
                "",
                "Po ceremonii dla Gości zostanie podstawiony autobus, który zawiezie wszystkich do sali weselnej.",
                "",
                "Od godziny 1:00 w nocy do dyspozycji Gości będzie samochód (do 8 osób), który zapewni bezpieczny powrót do domu."
            ]
        },
        {
            question: "Nocleg",
            answer: [
                "Dla Gości przyjeżdżających z dalszych miejscowości przygotowaliśmy możliwość noclegu.",
                "Zameldowanie będzie możliwe od godziny 14:00, a wymeldowanie do godziny 11:00.",
                "",
                "Śniadanie w formie bufetu będzie serwowane w sali restauracyjnej od godziny 6:30 do 10:30."
            ]
        },
        {
            question: "Poprawiny",
            answer: [
                "Dla tych, którzy będą mieli ochotę przedłużyć wspólne świętowanie, przygotowaliśmy również poprawiny, które odbędą się w swobodnej, domowej atmosferze – na ogródku u mamy Panny Młodej.",
                "",
                "Będzie ognisko, coś pysznego do jedzenia, czas na spokojne rozmowy i wspólne wspominanie weselnej nocy.",
                "",
                "Startujemy od godziny 16:00",
                "ul. Panewnicka 148A",
                "(wjazd od uliczki Rzecznej)",
                "",
                "Jeśli będziecie mieli ochotę i jeszcze trochę siły, będzie nam bardzo miło spędzić z Wami również ten czas."
            ],
            iframeSrc: "https://www.google.com/maps/embed/v1/place?key=AIzaSyDQ_Ao-DIExs3lQ7BAs-Zdw4ggY2zWrVlE&q=Panewnicka+148A,Katowice+Poland"
        },
        {
            question: "Potwierdzenie przybycia",
            answer: [
                "Prosimy o potwierdzenie swojej obecności do dnia 28.07.2026",
                "",
                "Kamila:  500 816 314",
                "Mateusz: 609 591 836"
            ]
        },        
        {
            question: "Trzaskanie",
            answer: [
                "Mówią, że im więcej potłuczonej porcelany, tym więcej szczęścia w małżeństwie. 😊",
                "Dlatego serdecznie zapraszamy Was na tradycyjne trzaskanie!",
                "",
                "Spotykamy się 15 sierpnia od godziny 16:00 u mamy Panny Młodej:",
                "📍 ul. Panewnicka 148A (wjazd od uliczki Rzecznej).",
                "",
                "Zabierzcie dobry humor, kawałek porcelany i pomóżcie nam rozpocząć tę nową przygodę z odrobiną hałasu. Niech zgodnie z tradycją przyniesie nam to szczęście na nowej drodze życia!"
            ],
            iframeSrc: "https://www.google.com/maps/embed/v1/place?key=AIzaSyDQ_Ao-DIExs3lQ7BAs-Zdw4ggY2zWrVlE&q=Panewnicka+148A,Katowice+Poland"
        },
        {
            question: "Ważne",
            answer: [
                "PS. Obowiązkowe wyposażenie gościa: uśmiech, pozytywna energia i gotowość do białego rana."
            ]
        }
    ];

    return (
        <Container sx={{ paddingLeft: { xs: 0, lg: 4 }, paddingRight: { xs: 0, lg: 4 } }}>
            {faqData.map((faq, index) => (
                <FaqItem
                    key={index}
                    question={faq.question}
                    answer={faq.answer}
                    iframeSrc={faq.iframeSrc}
                    quote={faq.quote}
                    quoteAuthor={faq.quoteAuthor}
                />
            ))}
        </Container>
    );
}